import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export function HomePage() {
  useEffect(() => {
    const previous = document.title
    document.title = 'AIAS MUSIC'
    return () => {
      document.title = previous
    }
  }, [])

  return (
    <section className="home">
      <div className="home-glow" aria-hidden="true" />
      <div className="home-inner">
        <img className="home-mark" src="/brand/aias-mark.png?v=20261018" alt="AIAS" width={512} height={512} />
        <div className="home-line" aria-hidden="true" />
        <Link className="btn home-cta" to="/music">
          Enter
        </Link>
      </div>
    </section>
  )
}
